export class MongoDbBackupConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "analyticsNodeMode",
            "baseName": "analyticsNodeMode",
            "type": "MongoDbBackupConfigAnalyticsNodeModeEnum",
            "format": ""
        },
        {
            "name": "scanThrottleMode",
            "baseName": "scanThrottleMode",
            "type": "MongoDbBackupConfigScanThrottleModeEnum",
            "format": ""
        },
        {
            "name": "scanThrottleRate",
            "baseName": "scanThrottleRate",
            "type": "number",
            "format": ""
        },
        {
            "name": "scanMaxQueuedReaders",
            "baseName": "scanMaxQueuedReaders",
            "type": "number",
            "format": ""
        },
        {
            "name": "scanStrategy",
            "baseName": "scanStrategy",
            "type": "MongoDbBackupConfigScanStrategyEnum",
            "format": ""
        },
        {
            "name": "cdcResolutionDuration",
            "baseName": "cdcResolutionDuration",
            "type": "string",
            "format": ""
        },
        {
            "name": "fullScanThresholdDuration",
            "baseName": "fullScanThresholdDuration",
            "type": "string",
            "format": ""
        },
        {
            "name": "coalesceIntervalDuration",
            "baseName": "coalesceIntervalDuration",
            "type": "string",
            "format": ""
        },
        {
            "name": "collectionPartitions",
            "baseName": "collectionPartitions",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreBulkWriteBatchSize",
            "baseName": "restoreBulkWriteBatchSize",
            "type": "number",
            "format": ""
        },
        {
            "name": "restoreMaxWorkers",
            "baseName": "restoreMaxWorkers",
            "type": "number",
            "format": ""
        },
        {
            "name": "backupBatchedWorkloadCap",
            "baseName": "backupBatchedWorkloadCap",
            "type": "number",
            "format": ""
        },
        {
            "name": "restoreBatchedPartitionCap",
            "baseName": "restoreBatchedPartitionCap",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MongoDbBackupConfig.attributeTypeMap;
    }
    constructor() {
    }
}
export var MongoDbBackupConfigAnalyticsNodeModeEnum;
(function (MongoDbBackupConfigAnalyticsNodeModeEnum) {
    MongoDbBackupConfigAnalyticsNodeModeEnum["Prefer"] = "PREFER";
    MongoDbBackupConfigAnalyticsNodeModeEnum["Require"] = "REQUIRE";
    MongoDbBackupConfigAnalyticsNodeModeEnum["DontUse"] = "DONT_USE";
})(MongoDbBackupConfigAnalyticsNodeModeEnum || (MongoDbBackupConfigAnalyticsNodeModeEnum = {}));
export var MongoDbBackupConfigScanThrottleModeEnum;
(function (MongoDbBackupConfigScanThrottleModeEnum) {
    MongoDbBackupConfigScanThrottleModeEnum["Latency"] = "latency";
    MongoDbBackupConfigScanThrottleModeEnum["Serverstats"] = "serverstats";
    MongoDbBackupConfigScanThrottleModeEnum["Ops"] = "ops";
    MongoDbBackupConfigScanThrottleModeEnum["Bytes"] = "bytes";
    MongoDbBackupConfigScanThrottleModeEnum["None"] = "none";
})(MongoDbBackupConfigScanThrottleModeEnum || (MongoDbBackupConfigScanThrottleModeEnum = {}));
export var MongoDbBackupConfigScanStrategyEnum;
(function (MongoDbBackupConfigScanStrategyEnum) {
    MongoDbBackupConfigScanStrategyEnum["ClusterParallel"] = "cluster_parallel";
    MongoDbBackupConfigScanStrategyEnum["SerialPerDatabase"] = "serial_per_database";
})(MongoDbBackupConfigScanStrategyEnum || (MongoDbBackupConfigScanStrategyEnum = {}));
